'use client';

/**
 * dispatch_sys の API クライアント。実体は共有モジュール（@new-cti/frontend-shared）。
 * createApi(authClient, appConfig) の戻り値を名前付き再エクスポートするため、呼び出し側の
 * `import { get, post, ... } from '@/lib/api'` は従来どおり動く。
 * GET は appConfig.getCache='no-store'（配車は常に最新表示）。
 */
import { createApi, type RecordLoginResult } from '@new-cti/frontend-shared/auth/api-core';
import { authClient } from './auth';
import { appConfig } from './app-config';

const apiClient = createApi(authClient, appConfig);

export const { get, post, put, del, recordLogin } = apiClient;

export type { RecordLoginResult };
